import { DataBean } from "../DataBean";

export class RawMaterial extends DataBean {

    public async getRawMaterialCatalog(idManufacturingStardard: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialCatalog_Number", [idManufacturingStardard]);
    }

}
